import {BI_ORIGINS} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {OldHeader} from '../../common/old-header'
import {SlideInModal} from '../../slide-in-modal'
import {Ticket} from '../ticket'
import {TicketDescriptionProps} from './interfaces'
import {classes} from './ticket-description.st.css'

export const OldTicketDescription = ({
  show,
  place,
  onClose,
  onTicketClick,
  showAccessibilityMode,
}: TicketDescriptionProps) => {
  const {t} = useTranslation()
  const {isMobile} = useEnvironment()

  const getBackButtonText = () => {
    if (isMobile) {
      return undefined
    }

    if (showAccessibilityMode) {
      return t('seatings_moreInfo_backToTicketList')
    }

    return t('seatings_moreInfo_backToBasket')
  }

  return (
    <SlideInModal
      id="ticket-description"
      className={isMobile ? undefined : classes.desktopSlideInModal}
      show={show}
      fromBottom={isMobile}
      onBackClick={isMobile ? undefined : onClose}
      backButtonText={getBackButtonText()}
      dataHook={DH.TICKET_DESCRIPTION}
    >
      <div>
        <OldHeader
          className={isMobile ? undefined : classes.desktopHeader}
          titleClassName={isMobile ? undefined : classes.desktopTitle}
          title={t('seatings_moreInfo_title')}
          closeModal={isMobile ? onClose : null}
        />
        <div className={classes.content}>
          {place ? (
            <Ticket
              showAccessibilityMode={showAccessibilityMode}
              onClick={onTicketClick}
              place={place}
              origin={BI_ORIGINS.SEATINGS_MODAL_TICKET_DESCRIPTION}
            />
          ) : null}
          <div>
            <Text tagName="p" className={classes.description}>
              {place?.ticket?.description}
            </Text>
          </div>
        </div>
      </div>
    </SlideInModal>
  )
}
